export default __webpack_public_path__ + "static/media/overview_icon_2.0a7d19a1.png";